<template>
  <div class="view-sample">
  
    <h2>Sample From {{sample.sample_date}} ({{locationName}}, {{varietyName}}):</h2>
    
    <div class="graphs">
      <TanninLevelDisplay v-if="levels[sample.var_id]" label="Skin Tannin"
                          :ranges="levels[sample.var_id].skin"
                          :value="sample.skin_tannin"/>
      <TanninLevelDisplay v-if="levels[sample.var_id]" label="Seed Tannin"
                          :ranges="levels[sample.var_id].seed"
                          :value="sample.seed_tannin"/>
    </div>

    <div class="stat-bar">
      <div class="stat">
        <div class="value">
          {{sample.seeds_per_berry}}
        </div>
        <span class="label">Seeds Per Berry</span>
      </div>
      <div class="stat">
        <div class="value">
          {{sample.berry_weight}}<span class="unit">g</span>
        </div>
        <span class="label">Fresh Berry Weight</span>
      </div>
      <div class="stat">
        <div class="value">
          {{sample.brix}}
        </div>
        <span class="label">Brix</span>
      </div>
      <div class="stat">
        <div class="value">
          {{sample.tit}}<span class="unit">g/L</span>
        </div>
        <span class="label">TA</span>
      </div>
      <div class="stat">
        <div class="value">
          {{sample.ph}}
        </div>
        <span class="label" style="text-transform: none">pH</span>
      </div>
      <div class="stat">
        <div class="value">
          {{sample.ace}}<span class="unit">g/L</span>
        </div>
        <span class="label">Acetic</span>
      </div>
    </div>

    
    <h2>Winemaking Suggestions:</h2>

    <div class="winemaking-notes-selector">
      <div class="input">
        <label class="input-label">Variety</label>
        <multiselect
          class="selectbox"
          selectLabel=""
          v-model="winemakingVariety"
          :options="varietyOptions"
          label="label" />
      </div>
      <div class="input">
        <label class="input-label">Skin Level</label>
        <multiselect
          class="selectbox"
          selectLabel=""
          v-model="winemakingSkinLevel"
          :options="levelOptions"
          label="label" />
      </div>
      <div class="input">
        <label class="input-label">Seed Level</label>
        <multiselect
          class="selectbox"
          selectLabel=""
          v-model="winemakingSeedLevel"
          :options="levelOptions"
          label="label" />
      </div>
    </div>
    <div class="actions" v-if="winemakingNotes && winemakingNotes.aim.length > 0">
      
      <h2>Aims</h2>
      <p>{{ winemakingNotes.aim }}</p>
  
      <h2>Suggestions</h2>
      <p>{{ winemakingNotes.suggestion }}</p>
  
      <h2>References</h2>
      <p>{{ winemakingNotes.refs }}</p>
    </div>
    <div class="actions" v-if="!winemakingNotes ||  winemakingNotes.aim.length <= 0">
      <h2>Notes coming soon...</h2>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import lodash from 'lodash';
import auth from '../auth';
import TanninLevelDisplay from '../components/TanninLevelDisplay';


export default {
  name: 'ViewSample',
  props: ['id'],
  components: {
    TanninLevelDisplay,
    Multiselect,
  },
  created() {
    this.$store.dispatch('getLevels').then(response => {
      this.getSample();
    }, error => {
      console.error(error);
    })
    this.$store.dispatch('getYears');
    this.$store.dispatch('getVarieties');
    this.$store.dispatch('getLocationsAll');
  },
  watch: {
    winemakingVariety: {
      handler() {
        // console.log(this.winemakingVariety);
        this.$store.dispatch('getWinemakingNotes', {
          var_id: this.winemakingVariety.value,
        });
      },
    },
  },
  data() {
    return {
      lodash,
      winemakingVariety: { label: '', value: 0 },
      levelOptions: [{ label: 'Low', value: 'low' }, { label: 'Medium', value: 'med' }, { label: 'High', value: 'high' }],
      winemakingSkinLevel: { label: '', value: '' },
      winemakingSeedLevel: { label: '', value: '' },
      sample: {
        ace: -1,
        berry_weight: -1,
        brix: -1,
        id: -1,
        loc_id: -1,
        ph: -1,
        sample_date: -1,
        seed_tannin: -1,
        seeds_per_berry: -1,
        skin_tanin: -1,
        tit: -1,
        var_id: -1,
      },
      varieties: [],
      locations: [],
    };
  },
  mounted() {
    //
  },
  methods: {
    getSample() {
      axios.get(`samples/${this.id}`)
        .then((resp) => {
          this.sample = resp.data;
          this.winemakingVariety = {
            label: this.varietyLabel(this.sample.var_id),
            value: this.sample.var_id,
          };
          this.winemakingSkinLevel = {
            label: lodash.upperFirst(
              this.valToLevel(this.sample.skin_tannin, this.levels[this.sample.var_id].skin),
            ),
            value: this.valToLevel(this.sample.skin_tannin, this.levels[this.sample.var_id].skin),
          };
          this.winemakingSeedLevel = {
            label: lodash.upperFirst(
              this.valToLevel(this.sample.seed_tannin, this.levels[this.sample.var_id].seed),
            ),
            value: this.valToLevel(this.sample.seed_tannin, this.levels[this.sample.var_id].seed),
          };
          console.log(this.sample);
        });
    },
    indexToLevelClass(index) {
      switch (index) {
        case 1:
          return 'low';
        case 2:
          return 'med';
        case 3:
          return 'high';
        default:
          return '';
      }
    },
    varietyLabel(id) {
      const results = this.$store.state.varieties.filter(item => item.id === id);
      if (results.length > 0) {
        return results[0].name;
      }
      return '';
    },
    valToLevel(val, levels) {
      let ret = 1;
      if (val > levels[1]) ret = 2;
      if (val > levels[2]) ret = 3;
      return this.indexToLevelClass(ret);
    },
  },
  computed: {
    winemakingNotes() {
      let ret = null;
      this.$store.state.winemakingNotes.forEach((note) => {
        if (note.skin_level === this.winemakingSkinLevel.value &&
          note.seed_level === this.winemakingSeedLevel.value) ret = note;
      });
      return ret;
    },
    levels() {
      return this.$store.state.levels;
    },
    skinLevel() {
      this.levels[this.sample.var_id].skin.forEach((level, index) => {
        if (this.sample.skinTannin <= level) {
          return this.indexToLevelClass(index);
        }
      });
      return '';
    },
    seedLevel() {
      this.levels[this.sample.var_id].seed.forEach((level, index) => {
        if (this.sample.seedTannin <= level) {
          return this.indexToLevelClass(index);
        }
      });
      return '';
    },
    varietyOptions() {
      const options = [];
      this.$store.state.varieties.forEach((variety) => {
        options.push({ label: variety.name, value: variety.id });
      });
      return options;
    },
    varietyName() {
      const results = this.$store.state.varieties.filter(item => item.id === this.sample.var_id);
      if (results.length > 0) {
        return results[0].name;
      }
      return '';
    },
    locationName() {
      const results = this.$store.state.locationsAll.filter(item => item.id === this.sample.loc_id);
      if (results.length > 0) {
        return results[0].name;
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/_colors.scss';
  @import '../assets/_globals.scss';

  .winemaking-notes-selector {
    color: $light-grey;
    background: #3b3b3b;
    margin-top: .5rem;
    padding:  .5rem .5rem 1rem .5rem;
    display: flex;
    width: 500px;
  }

  .input{
    flex: 1;
    padding: 0 .5rem;
    display: flex;
    flex-direction: column;
  }

  .input-label{
    margin-bottom: .25rem;
    color: $light-grey;
  }
  
  .view-sample{
    padding: 0;
  }

  .back-button{
    color: $red;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 1rem;
    padding: 0 1rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    .fa{
      margin-right: .25rem;
    }
  }

  .title-bar {
    height: 3rem;
    margin-top: .5rem;
    background: #f1f1f1;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: .5rem;
    font-weight: 400;
    position: relative;

    .title {
      flex: 1;
      text-align: center;
    }
  }

  .graphs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: .5rem;
    margin-bottom: .5rem;
  }

  .stat-bar {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    height: 5rem;
    background: #3B3B3B;
    color: $light-grey;
  }

  .stat {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .value {
    font-size: 1.5rem;
    font-weight: 400;
    .unit{
      font-size: 1.0rem;
    }
  }

  .label {
    text-transform: uppercase;
    margin-top: .2rem;
  }

  .actions{
    padding: 0 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ViewSample.vue